import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Fired when a user opens the New skill modal to save a skill, from the suggestion card or a bookmark button',
  name: 'skill_save_initiated',
  params: [
    {
      description: 'Which entry point opened the save-skill modal',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['suggestion', 'bookmark_fixed', 'bookmark_message'],
    },
  ],
};

export default META;
